import GameManager from "../../../../../GameManager";
import BaseScenario from "../../../../../Scenario/BaseScenario";
import BaseScenarioPart from "../../../../../Scenario/BaseScenarioPart";

export default class CoreDemoScenario extends BaseScenario {
	
	private parts: BaseScenarioPart<BaseScenario>[] = [];

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	public init(onDone: () => void): void {
	}

	public shouldLoadScenario(): boolean {
		return false
	}

	public getParts(): BaseScenarioPart<BaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return '';
	}
}